import { useCallback, useEffect, useState } from 'react';
import { useForm } from './useForm';
import { Item } from '../shared/components/InputSelect';
import ContaPagarController from '../controllers/ContaPagarController'
//import { formatarData } from '../../src/shared/utils/helpers/date';

export const useContasPagarVisualizar = () => {

  const [modalSearchProduct, setModalSearchProduct] = useState<boolean>(false);

  //const [productIsEditing, setProductIsEditing] = useState<boolean>(false);

  const [formaPagamento, setformaPagamento] = useState<Item[]>([]);

  const [condicaoParcelamento, setcondicaoParcelamento] = useState<Item[]>([]);

  const handleResetFormProduct = () => {
    // @ts-ignore - .
    formProduct.resetForm();
  };

  const [single, setSingle] = useState<any>(null);

  const getSingle = async (cpp_id: number) => {
    if (cpp_id) {
      const Response = await ContaPagarController.ListarUnico(cpp_id);
      setSingle(Response.Data);
    }
  };

  const handleOpenModalSearchProduct = (cpp_id: number) => {
    setModalSearchProduct(true);
    console.log('CPP_ID');
    console.log(cpp_id);
    
    getSingle(cpp_id);
  };

  const handleCloseModalSearchProduct = () => {
    setModalSearchProduct(false);
    handleResetFormProduct();
  };

  const onsubmit = (values: SubmitEvent) => {
    // handle form submission
    //console.log(values);
  };

  const formProduct = useForm({
    onSubmit: onsubmit,
    initialValues: {
      parcela: single?.dadosgerais.parcela,
      descricao: single?.dadosgerais.cp_descricao,
      fornecedor: single?.dadosgerais.cli_nome,
      valor: single?.parcela_unica.cpp_valor,
      data_emissao: single?.dadosgerais.cp_dataemissao,
      data_vencimento: single?.parcela_unica.cpp_vencimento,
      forma_pagamento: single?.dadosgerais.fpg_descricao,
      condicao_parcelamento: single?.dadosgerais.cpg_descricao,
      observacao: '',
      cpp_id: single?.dadosgerais.cpp_id,
      valorTotal: single?.dadosgerais.cpp_valor,
      valorPago: single?.dadosgerais.cpp_valor,
    }
  });

  const handleformaPagamento = useCallback(async () => {
    setformaPagamento([
      {
        value: '1',
        label: 'Boleto',
      },
      {
        value: '2',
        label: 'Cartão',
      },
      {
        value: '3',
        label: 'Pix',
      },
      {
        value: '4',
        label: 'Dinheiro',
      },
    ]);
  }, []);

  const handlecondicaoParcelamento = useCallback(async () => {
    setcondicaoParcelamento([
      {
        value: '1',
        label: 'À Vista',
      },
      {
        value: '2',
        label: 'Parcelado',
      },
    ]);
  }, []);

  const handleSelectOptions = () => {
    handleformaPagamento();
    handlecondicaoParcelamento();
  };

  useEffect(() => {
    handleSelectOptions();
  }, []);
  return {
    modalSearchProduct,
    handleCloseModalSearchProduct,
    formProduct,
    handleOpenModalSearchProduct,
    formaPagamento,
    condicaoParcelamento,
  };
};

export default useContasPagarVisualizar;